import Box from '@mui/material/Box';
import { GenericScheduleEmbed } from '../../app/common/Embed/GenericScheduleEmbed';
import React, { useEffect, useState } from 'react';
import useHotjarUser from '../../hooks/useHotjarUser';

const Time2BookIntake = (props) => {
  const {
    decodedName,
    decodedEmail,
    decodedLastName,
    decodedMobile,
    isDouble,
  } = props;

  useHotjarUser(undefined, {
    firstName: decodedName,
    email: decodedEmail,
  });

  const [toggle] = useState(false);
  const [iframePage, setIframePage] = useState();
  const [iframeId, setIframeId] = useState();

  useEffect(() => {
    setIframePage(
      isDouble ? 'pojoiwewnsesrtyqioeslwiogbs' : 'IntakeCallwithHealthConcierge'
    );
    setIframeId(
      isDouble
        ? 'SOIDIV_pojoiwewnsesrtyqioeslwiogbs'
        : 'SOIDIV_IntakeCallwithHealthConcierge'
    );
  }, []);

  return (
    <div
      style={{
        margin: 'auto',
        alignItems: 'center',
        display: 'flex',
        maxWidth: '900px',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingBottom: '40px',
        paddingTop: '20px',
        width: '100%',
      }}
    >
      <div
        style={{
          display: !toggle ? 'block' : 'none',
          width: '80%',
          height: '548px',
          maxWidth: '900px',
        }}
      >
        <GenericScheduleEmbed
          iframeId={iframeId}
          iframePage={iframePage}
          email={decodedEmail}
          name={decodedName}
          lastName={decodedLastName}
          phone={decodedMobile}
        />
      </div>
      <Box mb={2} />
    </div>
  );
};

export default Time2BookIntake;
